import { json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { Code } from '#app/components/typography/code.tsx'
import { H2 } from '#app/components/typography/h2.tsx'
import { P } from '#app/components/typography/p.tsx'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'Audio',
}

const component: componentProps = {
	name: 'Audio',
	shortName: 'Audio',
	fileName: 'audio',
	category: 'media',
	description: [`A video component.`],
	features: [``],
	usage: ``,
	parts: [],
	styling: ``,
}

export const loader = async () => {
	const source = await readSource({ category: component.category, fileName: component.fileName })
	return json({ source })
}

const Route = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Usage usage={usage} shortName={shortName} />
			<audio src="https://github.com/rafaelreis-hotmart/Audio-Sample-files/raw/master/sample.mp3" controls />

			<H2>Usage Notes</H2>
			<P>
				Be careful, while an image retains its <Code>width</Code> and <Code>height</Code> attributes after it loads, a video will override these attributes with its own dimensions once
				it loads.
			</P>
			<P>
				If the <Code>width</Code> and <Code>height</Code> attributes are not the same as the video's dimensions, this will cause a layout shift. This is why the video component sets the{' '}
				<Code>width</Code> and <Code>height</Code> attributes of the video element to the provided values while the video is loading, and then removes them once the video is ready.
			</P>
			<P>
				Make sure to either set the <Code>width</Code> and <Code>height</Code> attributes to the video's original resolution or style it with custom dimensions (e.g.{' '}
				<Code>w-[800px] h-[450px]</Code>). It's usually a good idea to respect the video's original ratio, otherwise you'll get{' '}
				<a href="https://en.wikipedia.org/wiki/Windowbox_(filmmaking)" target="_blank" rel="noreferrer" className="underline">
					windowboxing
				</a>
				.
			</P>

			<Features features={features} />
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default Route
